// AUDITORIA-CLINICA-REDISENO (FASE 3) -- lógica pura de la bandeja de
// auditoría: cómo se traduce lo que el auditor escribe a los parámetros que el
// endpoint YA acepta, y qué chips se muestran de vuelta.
//
// El listado `GET /audit/clinical/appointments` no tiene un filtro por número
// de atención (ver FASE 0 §4). En vez de inventarlo, el buscador reconoce
// "#3109" como un salto DIRECTO a esa atención -- y lo dice en el placeholder.

export const TABS_AUDITORIA = [
    { key: "PENDIENTE", label: "Pendientes" },
    { key: "EN_PROCESO", label: "En proceso" },
    { key: "AUDITADA", label: "Auditadas" },
];

// La bandeja audita atenciones FINALIZADAS (id_estado_cita = 6). No se expone
// como filtro: el listado clásico `/auditoria-clinica` sigue permitiendo
// cualquier estado de cita para quien lo necesite.
export const ESTADO_CITA_FINALIZADA = 6;

export const BANDEJA_FILTROS_VACIOS = {
    q: "",
    rango: null,
    cobertura: undefined,
    aseguradora: undefined,
    plan: undefined,
    doctor: undefined,
};

/** "#3109" o "3109" con `#` -> salto directo; cualquier otra cosa -> null. */
export function saltoDirecto(q) {
    const texto = String(q || "").trim();
    const m = /^#\s*(\d{1,10})$/.exec(texto);
    return m ? Number(m[1]) : null;
}

const soloDigitos = (v) => /^\d+$/.test(v);

/**
 * Traduce los filtros de la bandeja a los parámetros del endpoint. El buscador
 * único se reparte entre `documento` (si es todo dígitos) y `paciente` (si no),
 * que son los dos filtros de texto que el backend acepta.
 */
export function construirParametros(filtros, estadoAuditoria) {
    const f = filtros || {};
    const q = String(f.q || "").trim();
    const [desde, hasta] = f.rango || [];
    return {
        estado_cita: ESTADO_CITA_FINALIZADA,
        estado_auditoria: estadoAuditoria,
        fecha_desde: desde ? desde.format("YYYY-MM-DD") : undefined,
        fecha_hasta: hasta ? hasta.format("YYYY-MM-DD") : undefined,
        paciente: q && !soloDigitos(q) ? q : undefined,
        documento: q && soloDigitos(q) ? q : undefined,
        cobertura: f.cobertura,
        aseguradora: f.aseguradora,
        plan: f.plan,
        doctor: f.doctor,
    };
}

/**
 * Chips de los filtros aplicados. Cada uno sabe qué campo limpia, para que
 * quitarlo sea un clic y no "volver a armar el filtro".
 */
export function chipsAplicados(filtros, etiquetas = {}) {
    const f = filtros || {};
    const chips = [];
    const q = String(f.q || "").trim();
    if (q) chips.push({ campo: "q", texto: `Búsqueda: ${q}` });
    if (f.rango && f.rango[0] && f.rango[1]) {
        chips.push({ campo: "rango", texto: `${f.rango[0].format("DD/MM/YYYY")} — ${f.rango[1].format("DD/MM/YYYY")}` });
    }
    if (f.cobertura) chips.push({ campo: "cobertura", texto: `Cobertura: ${etiquetas.cobertura || f.cobertura}` });
    if (f.aseguradora !== undefined && f.aseguradora !== null) {
        chips.push({ campo: "aseguradora", texto: `Aseguradora: ${etiquetas.aseguradora || f.aseguradora}` });
    }
    if (f.plan !== undefined && f.plan !== null) chips.push({ campo: "plan", texto: `Plan: ${etiquetas.plan || f.plan}` });
    if (f.doctor !== undefined && f.doctor !== null) chips.push({ campo: "doctor", texto: `Médico: ${etiquetas.doctor || f.doctor}` });
    return chips;
}

export const hayFiltrosAplicados = (filtros) => chipsAplicados(filtros).length > 0;

/** Acción de fila según el estado de la revisión. Nunca "Editar". */
export function accionDeFila(estadoAuditoria) {
    if (estadoAuditoria === "EN_PROCESO") return { label: "Continuar", tipo: "primary" };
    if (estadoAuditoria === "AUDITADA") return { label: "Ver auditoría", tipo: "default" };
    return { label: "Auditar", tipo: "default" };
}
